import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import barChart from "./components//barChart";
export default {
  name: 'HitchStatList',
  mixins: [JeecgListMixin],
  components: {
    barChart: barChart
  },
  props: {
    width: {
      type: String,
      default: '100vw'
    },
    height: {
      type: String,
      default: '590px'
    }
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/repair/report',
      pageTitle: 'VIEW',
      pageChartTitle: '水站故障异常情况统计',
      // 表头
      columns: [{
        dataIndex: 'siteName',
        colName: 'siteName',
        title: '站点名称',
        align: 'center'
      }],
      siteTree: [],
      columnsData: []
    };
  },
  created: function created() {
    this.getSiteTree();
    this.getColumnsData();
    this.callback(); // this.getReportList()
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.size = 9;
      params.pageSize = -1;
      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      var siteId = '';

      if (this.queryParam.siteId) {
        this.queryParam.siteId.forEach(function (item, index) {
          if (index == 0) {
            siteId = item;
          } else {
            siteId = siteId + ',' + item;
          }
        });
      }

      params.siteIds = siteId;
      delete params.siteId;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total; // this.loadNums++

          _this.queryChartData();
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam.siteId = '';
      this.searchQuery();
    },
    getSiteTree: function getSiteTree() {
      var _this2 = this;

      getAction('/online/env/api/queryTreeList?addrType=1').then(function (res) {
        if (res.success) {
          _this2.reviseTree(res.result);

          _this2.siteTree = res.result;
        }
      });
    },
    reviseTree: function reviseTree(tree) {
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.children) {
          node['disabled'] = true;
          this.reviseTree(node.children);
        } else {
          node['disabled'] = false;
        }
      }
    },
    callback: function callback(key) {},
    getColumnsData: function getColumnsData() {
      var _this3 = this;

      getAction('/sys/dict/getDictItems/failure_cause').then(function (res) {
        if (res.success) {
          var currColumns = _this3.columns;
          res.result.forEach(function (item, index) {
            currColumns.push({
              dataIndex: item.value,
              colName: item.value,
              title: item.title,
              align: 'center'
            });

            _this3.columnsData.push({
              title: item.title,
              dataIndex: item.value,
              data: []
            });
          });
          currColumns.push({
            dataIndex: 'totalCount',
            colName: 'totalCount',
            title: '总数',
            align: 'center'
          });
          _this3.columns = currColumns;

          _this3.queryChartData();
        }
      });
    },
    // 柱状图数据
    queryChartData: function queryChartData() {
      var _this4 = this;

      var xData = [];
      this.dataSource.forEach(function (item, index) {
        if (item.siteName !== '合计') {
          xData.push(item.siteName);
        }
      });
      var data = {
        xData: xData,
        yData: [{
          type: 'value'
        }]
      };
      this.columnsData.forEach(function (item3, index) {
        item3.data = [];
      });
      this.dataSource.forEach(function (item, index) {
        _this4.columnsData.forEach(function (item1, index) {
          if (item.siteName !== '合计') {
            item1.data.push(item[item1.dataIndex]);
          }
        });
      });
      setTimeout(function () {
        console.log('data', data);
        console.log('this.columnsData', _this4.columnsData);

        _this4.$refs.chart.initBarChart(data, _this4.columnsData, _this4.pageChartTitle);
      }, 1000);
    }
  }
};